import * as activityConst from "./constants";
import transform from "./transform";
import {
  makeCall,
  makeDownload,
  handleProgramServiceError
} from "@/utils/request";
import _ from "lodash";
import { EVENT_TOAST_MESSAGE, EVENT_ERROR_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import { downloadFile } from "@/utils/download-file";
import commonUtils from "@/utils/common";

export const state = {
  isLoadingActivityData: false,
  programActivities: [],
  programActivitiesDetail: [],
  levelActivitiesFilter: {
    text: "",
    startDate: null,
    endDate: null,
    type: null,
    level: null,
    subgroup: null,
    filterDate: false
  },
  levelActivitiesModalFilter: {
    text: "",
    type: null
  },
  // activity phases
  phases: [],
  levelActivities: [],
  levelActivitiesClone: [],
  activityTemplates: [],
  activityTemplatesPagination: {
    count: 5,
    total: 0
  },
  // Employer Verified Activities table
  availableActivitiesEmployerVerified: [],
  availableActivitiesEmployerVerifiedPagination: {
    count: 5,
    total: 0
  },
  // activities source
  activitiesSummary: [],
  activitiesSummaryPagination: {
    count: 5,
    total: 0
  },
  // activities source
  availableActivities: [],
  availActivitiesPagination: {
    count: 5,
    total: 0
  },
  // activities of program
  customActivities: [],
  customActivitiesPagination: {
    count: 5,
    total: 0
  },
  programLevels: [],
  // activities of program - all level
  unassignedLevelActivities: [],
  unassignedLevelActivitiesPagination: {
    count: 5,
    total: 0
  },
  // activities of program - filter by level
  assignedLevelActivities: [],
  assignedLevelActivitiesPagination: {
    count: 5,
    total: 0
  },

  allProgramActivities: [],
  // old code ----
  availableActivityDetail: {},
  customActivityDetail: {},
  pagination: {
    count: 5,
    total: 0
  },
  calendarActivityModalOpen: false,
  allProgramActivitiesDetail: [],
  calendarPhaseSelectedId: 0,
  lesMillsResource: []
};

export const getters = {
  [activityConst.GETTERS_LEVEL_ACTIVITIES_MODAL_FILTERS]: state => {
    return state.levelActivitiesModalFilter;
  },
  [activityConst.GETTERS_LEVEL_ACTIVITIES_FILTERS]: state => {
    return state.levelActivitiesFilter;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_LIST]: state => {
    return state.programActivitiesDetail;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_DETAIL]: state => {
    let result = {};
    state.programActivitiesDetail.forEach(o => {
      result[o.id] = o;
    });
    if (state.programActivitiesDetail.length > 0) {
      state.programActivities.forEach(o => {
        if (result.hasOwnProperty(o.activityId)) {
          result[o.activityId].programPhaseId = o.programPhaseId;
        }
      });
    }
    return result;
  },
  [activityConst.GETTERS_PROGRAM_TEMPLATE_ACTIVITIES_DETAIL]: state => {
    let result = {};
    state.programActivitiesDetail.forEach(o => {
      result[o.templateActivityId] = o;
    });
    return result;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITY_LEVELS]: state => {
    return _.orderBy(state.levelActivities, ["levelId"], ["asc"]);
  },

  [activityConst.GETTERS_PROGRAM_ACTIVITY_LEVELS_CLONE]: state => {
    return state.levelActivitiesClone;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITY_PHASES]: state => {
    return _.orderBy(state.phases, ["phaseOrder", "id"], ["asc"]);
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_LEVELS]: state => {
    return state.programLevels;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_SUMMARY]: state => {
    return state.activitiesSummary;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_SUMMARY_PAGINATION]: state => {
    return state.activitiesSummaryPagination;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITY_TEMPLATES]: state => {
    return state.activityTemplates;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITY_TEMPLATES_PAGINATION]: state => {
    return state.activityTemplatesPagination;
  },
  [activityConst.GETTERS_PROGRAM_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED]: state => {
    return state.availableActivitiesEmployerVerified;
  },
  [activityConst.GETTERS_PROGRAM_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED_PAGINATION]: state => {
    return state.availableActivitiesEmployerVerifiedPagination;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED]: state => {
    return state.unassignedLevelActivities;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED_PAGINATION]: state => {
    return state.unassignedLevelActivitiesPagination;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED]: state => {
    return state.assignedLevelActivities;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED_PAGINATION]: state => {
    return state.assignedLevelActivitiesPagination;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_AVAILABLE]: state => {
    return state.availableActivities;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_AVAILABLE_PAGINATION]: state => {
    return state.availActivitiesPagination;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_CUSTOM]: state => {
    return state.customActivities;
  },
  [activityConst.GETTERS_PROGRAM_ACTIVITIES_CUSTOM_PAGINATION]: state => {
    return state.customActivitiesPagination;
  },
  [activityConst.GETTERS_GET_PROGRAM_ACTIVITY_AVAILABLE]: state => {
    return state.availableActivityDetail;
  },
  [activityConst.GETTERS_GET_PROGRAM_ACTIVITY_CUSTOM]: state => {
    return state.customActivityDetail;
  },
  [activityConst.GETTERS_GET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN]: state => {
    return state.calendarActivityModalOpen;
  },
  [activityConst.GETTERS_GET_ALL_PROGRAM_ACTIVITIES_DETAIL]: state => {
    return state.allProgramActivitiesDetail;
  },
  [activityConst.GETTERS_GET_CALENDAR_PHASE_SELECTED_ID]: state => {
    return state.calendarPhaseSelectedId;
  },
  [activityConst.GETTERS_IS_LOADING_ACTIVITY_DATA]: state => {
    return state.isLoadingActivityData;
  },
  [activityConst.GETTERS_GET_LES_MILLS_RESOURCE]: state => {
    return state.lesMillsResource;
  }
};

export const actions = {
  [activityConst.ACTION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN]: (
    { commit },
    value
  ) => {
    commit(
      activityConst.MUTATION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN,
      value
    );
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_UNASSIGNED_TO_LEVEL]: (
    { commit },
    options
  ) => {
    if (
      options.programId &&
      state.allProgramActivities &&
      state.allProgramActivities.length > 0
    ) {
      let unassignedIds = [-1];
      if (options.activityIds && options.activityIds.length > 0) {
        state.allProgramActivities.forEach(item => {
          if (!options.activityIds.includes(item.activityId)) {
            unassignedIds.push(item.activityId);
          }
        });
      } else {
        state.allProgramActivities.forEach(item => {
          unassignedIds.push(item.activityId);
        });
      }
      const urlAP = getEndPoints().program_activity.getCustomActivitiesByIds.replace(
        ":listId",
        unassignedIds.join(",")
      );
      makeCall(urlAP, buildOptions("GET", options), commit).then(responseAP => {
        if (responseAP) {
          let dataResponse = {
            responseProgramServ: state.allProgramActivities,
            responseAP: responseAP
          };
          commit(
            activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED,
            dataResponse
          );
          if (options.callback) {
            options.callback();
          }
        }
      });
    }
  },
  [activityConst.ACTION_GET_LES_MILLS_RESOURCE]: ({ commit }, options) => {
    const urlAP = getEndPoints().program_activity.getLesMillsResource.replace(
      ":searchString",
      options.searchString
    );
    makeCall(urlAP, buildOptions("GET", options)).then(response => {
      if (response) {
        commit(
          activityConst.MUTATION_SET_LES_MILLS_RESOURCE,
          response
        );
        if (options.callback) {
          options.callback();
        }
      }
    });
  },
  [activityConst.ACTION_GET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED]: ({ commit }, options) => {
    const url = getEndPoints().program_activity.getAvailableActivitiesEmployerVerified.replace(
      ":programId",
      options.programId
    );
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      commit(activityConst.MUTATION_SET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED, {
        data: response,
        assignedAct: []
      });
      if (options.callback) {
        options.callback();
      }
    });
  },
  [activityConst.ACTION_GET_ALL_ACTIVITY_TEMPLATES]: ({ commit }, options) => {
    const url = getEndPoints().program_activity.getAllActivitiesTemplates;
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITY_TEMPLATES, {
        data: response,
        assignedAct: []
      });
      if (options.callback) {
        options.callback();
      }
    });
  },
  [activityConst.ACTION_GET_ALL_ACTIVITY_CUSTOM_BY_PROGRAMID]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_activity.getAllActivitiesCustom.replace(
      ":programId",
      options.programId
    );
    if (options.getAll) {
      options.params = {
        limit: 1000
      };
    }
    makeCall(url, buildOptions("GET", options), commit)
      .then(response => {
        commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITY_TEMPLATES, {
          data: response,
          assignedAct: []
        });
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        handleProgramServiceError(error);
      });
  },
  [activityConst.ACTION_GET_ALL_ACTIVITY_CUSTOM_DETAIL_BY_PROGRAMID]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_activity.getAllActivitiesCustom.replace(
      ":programId",
      options.programId
    );
    makeCall(url, buildOptions("GET", options), commit).then(response => {
      commit(
        activityConst.MUTATION_SET_ALL_PROGRAM_ACTIVITIES_DETAIL,
        response
      );
      if (options.callback) {
        options.callback(response);
      }
    });
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITY_TEMPLATES]: (
    { commit },
    options
  ) => {
    if (options.programId) {
      const url = getEndPoints().program_activity.getAvailableActivities.replace(
        ":programId",
        options.programId
      );
      return makeCall(url, buildOptions("GET", options)).then(response => {
        if (response.data) {
          commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITY_TEMPLATES, {
            data: response,
            assignedAct: options.assignActivities
          });
          if (options.callback) {
            options.callback();
          }
        }
      });
    }
  },
  [activityConst.ACTION_ADD_ACTIVITY_TO_PHASE]: ({ commit }, options) => {
    if (options.data) {
      const urlAddActivityAP = getEndPoints().program_activity
        .addCustomActivity;
      return makeCall(
        urlAddActivityAP,
        buildOptions("POST", options.data.selectedActivity)
      )
        .then(responseCustomActivity => {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(responseCustomActivity);
          }
        })
        .catch(function(error) {
          handleProgramServiceError(error);
          return Promise.reject(error);
        });
    }
  },
  [activityConst.ACTION_MOVE_ACTIVITY_TO_PHASE]: ({ commit }, options) => {
    const urlAddActivityProgram = getEndPoints().program_phases.updatePhase;
    makeCall(
      urlAddActivityProgram,
      buildOptions("PUT", options.data),
      commit
    ).then(responseProgramActivity => {
      if (options.callback) {
        options.callback(responseProgramActivity);
      }
    });
  },
  [activityConst.ACTION_ADD_PROGRAM_ACTIVITY_PHASE]: ({ commit }, options) => {
    if (options.programId) {
      const urlAP = getEndPoints().program_phases.add;
      return makeCall(urlAP, buildOptions("POST", options)).then(response => {
        if (response) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          commit(activityConst.MUTATION_ADD_PROGRAM_ACTIVITY_PHASE, response);
          if (options.callback) {
            options.callback();
          }
        }
      }).catch(() => {
        if (options.callback) {
          options.callback();
        }
      });
    }
  },
  [activityConst.ACTION_EDIT_PROGRAM_ACTIVITY_PHASE]: ({ commit }, options) => {
    if (!options.id || !options.programId) {
      return;
    }
    const urlAP = getEndPoints().program_phases.edit;
    return makeCall(urlAP, buildOptions("PUT", options)).then(response => {
      if (response) {
        if (options.showMessageSuccess) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        }
        commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITY_PHASE, response);
        if (options.callback) {
          return options.callback();
        }
      }
    });
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITY_PHASES]: ({ commit }, options) => {
    if (options.programId) {
      const urlAP = getEndPoints().program_phases.getByProgramId.replace(
        ":programId",
        options.programId
      );
      options.params = {
        limit: 20
      };
      makeCall(urlAP, buildOptions("GET", options)).then(response => {
        if (response.data) {
          commit(
            activityConst.MUTATION_SET_PROGRAM_ACTIVITY_PHASES,
            response.data
          );
          if (options.callback) {
            options.callback();
          }
        }
      });
    }
  },
  [activityConst.ACTION_GET_ACTIVITIES_BY_PHASE_ID]: ({ commit }, options) => {
    if (options.programId && options.phaseId) {
      const urlProgServ = getEndPoints()
        .program_activity.getActivitiesByPhasesProgramServ.replace(
          ":programId",
          options.programId
        )
        .replace(":phaseId", options.phaseId);
      if (!_.has(options, "params.size") && _.has(options, "params.limit")) {
        options.params.size = options.params.limit;
      }
      return makeCall(
        urlProgServ,
        buildOptions("GET", { params: options.params || {} }),
        commit
      ).then(responseProgServ => {
        if (responseProgServ.data) {
          commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_BY_PHASE, {
            resProg: responseProgServ,
            phaseId: options.phaseId
          });
          if (options.callback) {
            options.callback(options.phaseId);
          }
        }
      });
    }
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_DETAILS]: (
    { commit },
    options
  ) => {
    if (options.activities && options.activities.length > 0) {
      let ids = [];
      options.activities.forEach(o => {
        ids.push(o.activityId);
      });
      const url = getEndPoints().program_activity.getCustomActivitiesByIds.replace(
        ":listId",
        ids.join(",")
      );
      if (options.getAll) {
        options.params = {
          limit: 1000
        };
      }
      makeCall(url, buildOptions("GET", options), commit).then(response => {
        commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_DETAIL, response);
        if (options.callback) {
          options.callback();
        }
      });
    } else {
      if (options.callback) {
        options.callback();
      }
    }
  },
  [activityConst.ACTION_GET_ACTIVITIES_BY_LEVEL_ID]: ({ commit }, options) => {
    if (options.activitiesProgram && options.activitiesProgram.length > 0) {
      let ids = [];
      options.activitiesProgram.forEach(item => {
        ids.push(item.ActivityId);
      });
      const urlAP = getEndPoints().program_activity.getCustomActivitiesByIds.replace(
        ":listId",
        ids.join(",")
      );
      options.params.limit = 1000;
      commit(activityConst.MUTATION_SET_IS_LOADING_ACTIVITY_DATA, true);
      makeCall(urlAP, buildOptions("GET", options), commit)
        .then(responseAP => {
          commit(activityConst.MUTATION_SET_IS_LOADING_ACTIVITY_DATA, false);
          commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_BY_LEVEL, {
            levelId: options.levelId,
            levelName: options.levelName,
            activitiesAP: responseAP,
            activitiesProgram: options.activitiesProgram
          });
          if (options.callback) {
            options.callback(options.phaseId);
          }
        })
        .catch(error => {
          if (options.callback) {
            options.callback(error);
          }
        });
    } else {
      commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_BY_LEVEL, {
        levelId: options.levelId,
        levelName: options.levelName
      });
      if (options.callback) {
        options.callback();
      }
    }
  },
  [activityConst.ACTION_DELETE_PROGRAM_ACTIVITY_PHASE]: (
    { commit },
    options
  ) => {
    if (options.phaseId) {
      const urlAP = getEndPoints().program_phases.delete.replace(
        ":phaseId",
        options.phaseId
      );
      makeCall(urlAP, buildOptions("DELETE", {}), commit).then(() => {
        commit(
          activityConst.MUTATION_DELETE_PROGRAM_ACTIVITY_PHASE,
          options.phaseId
        );
        EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
        if (options.callback) {
          options.callback();
        }
      });
    }
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_SUMMARY]: (
    { commit },
    options
  ) => {
    if (options.programId) {
      const urlAP = getEndPoints().program_activity.getProgramActivitiesFromAP.replace(
        ":programId",
        options.programId
      );
      makeCall(urlAP, buildOptions("GET", options), commit).then(response => {
        commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_SUMMARY, response);
        if (options.callback) {
          options.callback();
        }
      });
    }
  },
  [activityConst.ACTION_INIT_PROGRAM_ACTIVITIES_LEVEL]: (
    { commit },
    levelList
  ) => {
    commit(activityConst.MUTATION_SET_LEVEL_LIST, levelList);
  },
  // --- Old code - TODO: Refactor / remove
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_AVAILABLE]: (
    { commit },
    options
  ) => {
    if (options.programId) {
      const url = getEndPoints().program_activity.getAvailableActivities.replace(
        ":programId",
        options.programId
      );
      makeCall(url, buildOptions("GET", options), commit).then(response => {
        if (response.data) {
          commit(
            activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_AVAILABLE,
            response
          );
        }
      });
    }
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITY_AVAILABLE]: (
    { commit },
    options
  ) => {
    if (options.id) {
      const url = getEndPoints().program_activity.getAvailableActivity.replace(
        ":id",
        options.id
      );
      makeCall(url, buildOptions("GET", {}), commit).then(
        response => {
          if (response) {
            commit(
              activityConst.MUTATION_SET_PROGRAM_ACTIVITY_AVAILABLE,
              response
            );
          }
        },
        error => {
          console.log("error =", error);
        }
      );
    }
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_CUSTOM]: (
    { commit },
    options
  ) => {
    if (options.programId) {
      const urlAP = getEndPoints().program_activity.getProgramActivitiesFromAP.replace(
        ":programId",
        options.programId
      );
      makeCall(urlAP, buildOptions("GET", options), commit).then(responseAP => {
        let dataResponse = {
          responseProgramServ: state.allProgramActivities,
          responseAP: responseAP
        };
        commit(
          activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_CUSTOM,
          dataResponse
        );
        if (options.callback) {
          options.callback();
        }
      });
    }
  },
  [activityConst.ACTION_GET_ALL_PROGRAM_ACTIVITIES]: ({ commit }, options) => {
    if (options.programId) {
      const urlProgramServ = getEndPoints().program_activity.getProgramActivity.replace(
        ":id",
        options.programId
      );
      makeCall(
        urlProgramServ,
        buildOptions("GET", { params: { limit: 1000 } }),
        commit
      ).then(response => {
        commit(
          activityConst.MUTATION_SET_ALL_PROGRAM_ACTIVITIES,
          response.data
        );
        if (options.callback) {
          options.callback();
        }
      });
    }
  },
  [activityConst.ACTION_SET_PROGRAM_ACTIVITIES_STATE]: (
    { commit },
    options
  ) => {
    commit(
      activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_STATE,
      options.programLevels
    );
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED]: (
    { commit },
    options
  ) => {
    if (
      options.programId &&
      state.allProgramActivities &&
      state.allProgramActivities.length > 0
    ) {
      let unassignedIds = [];
      let allProgramActivities = state.allProgramActivities;
      allProgramActivities.forEach(item => {
        if (options.activityIds && options.activityIds.length > 0) {
          if (!options.activityIds.includes(item.activityId)) {
            unassignedIds.push(item.activityId);
          }
        } else {
          unassignedIds.push(item.activityId);
        }
      });
      const urlAP = getEndPoints().program_activity.getCustomActivitiesByIds.replace(
        ":listId",
        unassignedIds.join(",")
      );
      makeCall(urlAP, buildOptions("GET", options), commit).then(responseAP => {
        if (responseAP) {
          let dataResponse = {
            responseProgramServ: allProgramActivities,
            responseAP: responseAP
          };
          commit(
            activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED,
            dataResponse
          );
          if (options.callback) {
            options.callback();
          }
        }
      });
    }
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED]: (
    { commit },
    options
  ) => {
    if (
      options.programId &&
      state.allProgramActivities &&
      state.allProgramActivities.length > 0
    ) {
      if (options.activityIds && options.activityIds.length > 0) {
        const urlAP = getEndPoints().program_activity.getCustomActivitiesByIds.replace(
          ":listId",
          options.activityIds.join(",")
        );
        makeCall(urlAP, buildOptions("GET", options), commit).then(
          responseAP => {
            if (responseAP) {
              let dataResponse = {
                responseProgramServ: state.allProgramActivities,
                responseAP: responseAP
              };
              commit(
                activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED,
                dataResponse
              );
              if (options.callback) {
                options.callback();
              }
            }
          }
        );
      } else {
        commit(activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED, {
          responseProgramServ: [],
          responseAP: []
        });
      }
    }
  },
  [activityConst.ACTION_BULK_ADD_PROGRAM_CUSTOM_ACTIVITIES]: (
    { commit },
    options
  ) => {
    if (
      options.data &&
      options.data.programId &&
      options.data.customActivities &&
      options.data.customActivities.length > 0
    ) {
      const url = getEndPoints().program_activity.bulkCreateCustomActivities;
      makeCall(
        url,
        buildOptions("POST", {
          customActivities: options.data.customActivities
        }),
        commit
      ).then(responseCustomActivity => {
        if (responseCustomActivity.error && options.errorHandling) {
          options.errorHandling(responseCustomActivity.error);
        } else if (responseCustomActivity.customActivities) {
          const urlAddActivityProgram = getEndPoints().program_activity.bulkCreateProgramActivities.replace(
            ":id",
            options.data.programId
          );
          let activityProgramBulkAddModel = transform.convertProgramActivityBulkAddModel(
            options.data,
            responseCustomActivity.customActivities
          );
          makeCall(
            urlAddActivityProgram,
            buildOptions("POST", activityProgramBulkAddModel),
            commit
          ).then(responseProgramActivity => {
            EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
            if (options.callback) {
              options.callback(responseProgramActivity);
            }
          });
        }
      });
    }
  },
  [activityConst.ACTION_SET_ACTIVITIES_TO_LEVEL]: ({ commit }, options) => {
    if (options.data.levelId) {
      const url = getEndPoints().program_level_activities.addActivitiesToLevel.replace(
        ":id",
        options.data.levelId
      );
      makeCall(url, buildOptions("POST", options.data.activities), commit).then(
        response => {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(response);
          }
        }
      );
    }
  },
  [activityConst.ACTION_SET_ACTIVITY_TO_LEVEL]: ({ commit }, options) => {
    if (options.data.activityId) {
      const url = getEndPoints().program_level_activities.addActivityToLevel;
      makeCall(url, buildOptions("POST", options.data), commit).then(
        response => {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(response);
          }
        }
      );
    }
  },
  [activityConst.ACTION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY]: (
    { commit },
    options
  ) => {
    commit(
      activityConst.MUTATION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY,
      options.data
    );
    if (options.callback) {
      options.callback();
    }
  },
  [activityConst.ACTION_REFRESH_PHASE_AFTER_DELETION]: (
    { commit },
    options
  ) => {
    if (options.phaseId && options.removeProgramActivityIds) {
      commit(activityConst.MUTATION_REFRESH_PHASE_AFTER_DELETION, {
        phaseId: options.phaseId,
        removeIds: options.removeProgramActivityIds
      });
    }
  },
  [activityConst.ACTION_BULK_DELETE_PROGRAM_CUSTOM_ACTIVITIES]: (
    { commit },
    options
  ) => {
    if (options.data) {
      let programActIds = options.data.programActivityIds;
      if (programActIds && programActIds.length > 0) {
        const urlProgramServ = getEndPoints().program_activity.bulkDeleteProgramActivities.replace(
          ":programId",
          options.data.programId
        );
        return makeCall(
          urlProgramServ,
          buildOptions("POST", programActIds),
          commit
        )
          .then(() => {
            EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
            if (options.callback) {
              options.callback(programActIds);
            }
          })
          .catch(function(error) {
            handleProgramServiceError(error);
            return Promise.reject(error);
          });
      }
    }
  },
  [activityConst.ACTION_BULK_EDIT_PROGRAM_CUSTOM_ACTIVITIES]: (
    { commit },
    options
  ) => {
    if (options.data) {
      const url = getEndPoints().program_activity.bulkEditProgramActivitiesDate;
      makeCall(url, buildOptions("POST", options.data), commit).then(
        response => {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(response);
          }
        }
      );
    }
  },
  [activityConst.ACTION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM]: ({ commit }) => {
    commit(activityConst.MUTATION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM);
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITY_CUSTOM_TEMPLATE]: (
    { commit },
    options
  ) => {
    if (options.id) {
      const url = getEndPoints().program_activity.getCustomActivityTemplate.replace(
        ":id",
        options.id
      );
      makeCall(url, buildOptions("GET", {}), commit).then(
        response => {
          if (response) {
            commit(
              activityConst.MUTATION_SET_PROGRAM_ACTIVITY_CUSTOM,
              response
            );
            if (options.callback) {
              options.callback(response);
            }
          }
        },
        error => {
          console.log("error =", error);
        }
      );
    }
  },
  [activityConst.ACTION_GET_PROGRAM_ACTIVITY_CUSTOM]: ({ commit }, options) => {
    if (options.id) {
      const url = getEndPoints().program_activity.getCustomActivity.replace(
        ":id",
        options.id
      );
      makeCall(url, buildOptions("GET", {}), commit).then(
        response => {
          if (response) {
            commit(
              activityConst.MUTATION_SET_PROGRAM_ACTIVITY_CUSTOM,
              response
            );
            if (options.callback) {
              options.callback(response);
            }
          }
        },
        error => {
          console.log("error =", error);
        }
      );
    }
  },
  [activityConst.ACTION_DELETE_PROGRAM_ACTIVITY_CUSTOM]: (
    { commit },
    options
  ) => {
    if (options.programId && options.activityId) {
      const url = getEndPoints()
        .program_activity.deleteProgramActivity.replace(
          ":programId",
          options.programId
        )
        .replace(":activityId", options.activityId);
      makeCall(url, buildOptions("DELETE", {}), commit).then(() => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Delete Successful!");
        if (options.callback) {
          options.callback();
        }
      });
    }
  },
  [activityConst.ACTION_UPDATE_PROGRAM_ACTIVITY_CUSTOM]: (
    { commit },
    options
  ) => {
    if (options.data && options.data.id > 0) {
      const url = getEndPoints().program_activity.update;
      makeCall(url, buildOptions("POST", options.data), commit).then(
        responseAP => {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          if (options.callback) {
            options.callback(responseAP);
          }
        }
      );
    }
  },
  [activityConst.ACTION_UPDATE_PROGRAM_PHASE_ACTIVITY_CUSTOM]: (
    { commit },
    options
  ) => {
    const url = getEndPoints().program_activity.updatePhase;
    makeCall(url, buildOptions("POST", options.data), commit).then(
      responseAP => {
        EventBus.$emit(EVENT_TOAST_MESSAGE, "Update Successful!");
        if (options.callback) {
          options.callback(responseAP);
        }
      }
    );
  },
  [activityConst.ACTION_SAVE_PROGRAM_ACTIVITIES]: ({ commit }, options) => {
    const url = getEndPoints().program_activity.saveCustomActivities;
    makeCall(url, buildOptions("POST", options.data), commit)
      .then(response => {
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
      });
  },
  [activityConst.ACTION_SEARCH_PROGRAM_ACTIVITIES]: ({ commit }, options) => {
    const url =
      getEndPoints().program_activity.searchProgramActivities.replace(
        ":programId",
        options.programId
      ) +
      "?" +
      options.params;
    makeCall(url, buildOptions("GET", {}), commit)
      .then(response => {
        if (options.callback) {
          options.callback(response);
        }
      })
      .catch(function(error) {
        EventBus.$emit(
          EVENT_ERROR_TOAST_MESSAGE,
          error.response.data.error.message.title || error
        );
      });
  }
};

export const mutations = {
  [activityConst.MUTATION_SET_ALL_PROGRAM_ACTIVITIES_DETAIL]: (
    state,
    payload
  ) => {
    if (payload.data) {
      state.allProgramActivitiesDetail = payload.data;
    }
  },
  [activityConst.MUTATION_SET_PROGRAM_CALENDAR_ACTIVITY_MODAL_OPEN]: (
    state,
    value
  ) => {
    state.calendarActivityModalOpen = value;
  },
  [activityConst.MUTATION_SET_LEVEL_LIST]: state => {
    state.levelActivities = [];
    state.levelActivitiesClone = [];
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_DETAIL]: (state, payload) => {
    state.programActivitiesDetail = payload.data;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_BY_LEVEL]: (
    state,
    options
  ) => {
    if (!options.activitiesAP) {
      let newObj = {
        levelId: options.levelId,
        levelName:
          options.levelName && options.levelName.length > 0
            ? options.levelName
            : "",
        data: [],
        pagination: { current_page: 1, itemsPerPage: 5, total: 0 }
      };
      if (
        _.findIndex(state.levelActivities, a => {
          return a.levelId === options.levelId;
        }) === -1
      ) {
        state.levelActivities.push(newObj);
      }
    } else {
      let activitiesAP = options.activitiesAP;
      let activitiesProg = options.activitiesProgram;
      let dataAct = transform.convertLevelActivitiesWithSubgroupViewModel(
        activitiesAP,
        activitiesProg
      );
      let paginationAct =
        activitiesAP.meta && activitiesAP.meta.pagination
          ? {
              ...{
                count: activitiesAP.meta.pagination.count,
                total: parseInt(activitiesAP.meta.pagination.total),
                itemsPerPage: activitiesAP.meta.pagination.per_page,
                totalPage: activitiesAP.meta.pagination.total_pages,
                current_page: parseInt(
                  activitiesAP.meta.pagination.current_page
                )
              }
            }
          : { count: 5, total: 0 };
      let newObj = {
        levelId: options.levelId,
        levelName:
          options.levelName && options.levelName.length > 0
            ? options.levelName
            : "",
        data: dataAct,
        pagination: paginationAct
      };
      if (state.levelActivities.length === 0) {
        state.levelActivities.push(newObj);
      } else {
        const index = state.levelActivities.findIndex(
          t => t.levelId.toString() === options.levelId.toString()
        );
        if (index >= 0) {
          state.levelActivities[index] = newObj;
        } else {
          state.levelActivities.push(newObj);
        }
      }
    }
    state.levelActivities = Object.assign([], state.levelActivities);
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_CLONE_BY_LEVEL]: state => {
    state.levelActivitiesClone = Object.assign([], state.levelActivities);
    state.levelActivitiesClone = _.orderBy(
      state.levelActivitiesClone,
      ["levelId"],
      ["asc"]
    );
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_BY_PHASE]: (
    state,
    options
  ) => {
    let activitiesProg = options.resProg;
    let dataAct = transform.convertProgramActivitiesViewModel(activitiesProg);
    let paginationAct =
      activitiesProg.meta && activitiesProg.meta.pagination
        ? {
            ...{
              count: activitiesProg.meta.pagination.count,
              total: parseInt(activitiesProg.meta.pagination.total),
              itemsPerPage: activitiesProg.meta.pagination.per_page,
              totalPage: activitiesProg.meta.pagination.total_pages,
              current_page: parseInt(
                activitiesProg.meta.pagination.current_page
              )
            }
          }
        : { count: 5, total: 0 };
    const index = state.phases.findIndex(
      t => t.id.toString() === options.phaseId.toString()
    );
    if (index >= 0) {
      state.phases[index].activities = {
        data: dataAct,
        pagination: paginationAct
      };

      state.phase = [...state.phases];
    }
  },
  [activityConst.MUTATION_ADD_PROGRAM_ACTIVITY_PHASE]: (state, phase) => {
    phase.activities = {
      data: [],
      pagination: {}
    };
    state.phases.push(phase);
  },
  [activityConst.MUTATION_DELETE_PROGRAM_ACTIVITY_PHASE]: (state, phaseId) => {
    const index = state.phases.findIndex(
      t => t.id.toString() === phaseId.toString()
    );
    if (index >= 0) {
      state.phases.splice(index, 1);
    }
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITY_PHASE]: (state, phase) => {
    const index = state.phases.findIndex(t => t.id === phase.id);
    if (index >= 0) {
      state.phases[index].startDate = commonUtils.getDateFromDateTime(phase.startDate);
      state.phases[index].endDate = commonUtils.getDateFromDateTime(phase.endDate);
    }
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITY_PHASES]: (state, phases) => {
    phases.forEach(element => {
      element.activities = {
        data: [],
        pagination: {}
      };
      element.startDate = commonUtils.getDateFromDateTime(element.startDate);
      element.endDate = commonUtils.getDateFromDateTime(element.endDate);
    });
    state.phases = phases;
  },
  [activityConst.MUTATION_SET_DEFAULT_PROGRAM_ACTIVITIES_SUMMARY]: state => {
    state.activitiesSummary = [];
    state.activitiesSummaryPagination = { count: 5, total: 0 };
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_SUMMARY]: (
    state,
    activities
  ) => {
    let dataProgramServ = state.allProgramActivities;
    let dataViewModel = transform.convertProgramActivitiesViewModel(activities);
    dataViewModel.forEach(item => {
      item.RequiredFor = " ";
      const index = dataProgramServ.findIndex(
        t => t.activityId === item.id.toString()
      );
      if (index >= 0) {
        item.ProgramActivityId = dataProgramServ[index].id || "";
        if (
          dataProgramServ[index].assignToLevel &&
          dataProgramServ[index].assignToLevel.length > 0
        ) {
          item.RequiredFor = "Level " + dataProgramServ[index].assignToLevel;
        }
      }
    });
    state.activitiesSummary = dataViewModel;
    state.activitiesSummaryPagination =
      activities.meta && activities.meta.pagination
        ? {
            ...{
              count: activities.meta.pagination.count,
              total: parseInt(activities.meta.pagination.total),
              itemsPerPage: activities.meta.pagination.perpage,
              totalPage: activities.meta.pagination.total_pages,
              current_page: parseInt(activities.meta.pagination.current_page)
            }
          }
        : state.activitiesSummaryPagination;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_AVAILABLE]: (
    state,
    activities
  ) => {
    state.availableActivities = transform.convertProgramActivitiesViewModel(
      activities
    );
    state.availActivitiesPagination =
      activities.meta && activities.meta.pagination
        ? {
            ...{
              count: activities.meta.pagination.count,
              total: parseInt(activities.meta.pagination.total),
              itemsPerPage: activities.meta.pagination.per_page,
              totalPage: activities.meta.pagination.total_pages,
              current_page: parseInt(activities.meta.pagination.current_page)
            }
          }
        : state.availActivitiesPagination;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITY_TEMPLATES]: (state, params) => {
    let activities = params.data;
    let assignActs = params.assignedAct;
    state.activityTemplates = transform.convertActivityTemplatesViewModel(
      activities,
      assignActs
    );
    state.activityTemplatesPagination =
      activities.meta && activities.meta.pagination
        ? {
            ...{
              count: activities.meta.pagination.count,
              total: parseInt(activities.meta.pagination.total),
              itemsPerPage: activities.meta.pagination.per_page,
              totalPage: activities.meta.pagination.total_pages,
              current_page: parseInt(activities.meta.pagination.current_page)
            }
          }
        : state.activityTemplatesPagination;
  },
  [activityConst.MUTATION_SET_AVAILABLE_ACTIVITIES_EMPLOYER_VERIFIED]: (state, params) => {
    let activities = params.data;
    let assignActs = params.assignedAct;
    state.availableActivitiesEmployerVerified = transform.convertActivityTemplatesViewModel(
      activities,
      assignActs
    );
    state.availableActivitiesEmployerVerifiedPagination =
      activities.meta && activities.meta.pagination
        ? {
            ...{
              count: activities.meta.pagination.count,
              total: parseInt(activities.meta.pagination.total),
              itemsPerPage: activities.meta.pagination.per_page,
              totalPage: activities.meta.pagination.total_pages,
              current_page: parseInt(activities.meta.pagination.current_page)
            }
          }
        : state.activityTemplatesPagination;
  },
  [activityConst.MUTATION_RESET_PROGRAM_ACTIVITY_TEMPLATES]: state => {
    state.activityTemplates = [];
    state.activityTemplatesPagination = {
      count: 5,
      total: 0
    };
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_CUSTOM]: (state, data) => {
    let dataAP = data.responseAP;
    let dataProgramServ = data.responseProgramServ;
    let dataViewModel = transform.convertProgramActivitiesViewModel(dataAP);
    dataViewModel.forEach(item => {
      const index = dataProgramServ.findIndex(
        t => t.activityId === item.id.toString()
      );
      if (index >= 0) {
        item.ProgramActivityId = dataProgramServ[index].id || "";
      }
    });
    state.customActivities = dataViewModel;
    state.customActivitiesPagination =
      dataAP.meta && dataAP.meta.pagination
        ? {
            ...{
              count: dataAP.meta.pagination.count,
              total: parseInt(dataAP.meta.pagination.total),
              itemsPerPage: dataAP.meta.pagination.per_page,
              totalPage: dataAP.meta.pagination.total_pages,
              current_page: parseInt(dataAP.meta.pagination.current_page)
            }
          }
        : state.customActivitiesPagination;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_STATE]: (state, data) => {
    state.programLevels = [];
    data.forEach(level => {
      let item = {
        LevelId: level.Id,
        LevelName: level.Name,
        Activities: level.Activities,
        ActivityIds: [],
        ProgramActivityIds: []
      };
      if (level.Activities && level.Activities.length > 0) {
        level.Activities.forEach(activity => {
          item.ActivityIds.push(activity.ActivityId);
          item.ProgramActivityIds.push(activity.Id);
        });
      }
      state.programLevels.push(item);
    });
  },
  [activityConst.MUTATION_SET_ALL_PROGRAM_ACTIVITIES]: (state, data) => {
    state.allProgramActivities = data;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_UNASSIGNED]: (
    state,
    data
  ) => {
    let dataAP = data.responseAP;
    let dataProgramServ = data.responseProgramServ;
    let dataViewModel = transform.convertProgramActivitiesViewModel(dataAP);
    dataViewModel.forEach(item => {
      const index = dataProgramServ.findIndex(
        t => t.activityId === item.id.toString()
      );
      if (index >= 0) {
        item.ProgramActivityId = dataProgramServ[index].id || "";
      }
    });
    state.unassignedLevelActivities = dataViewModel;
    state.unassignedLevelActivitiesPagination =
      dataAP.meta && dataAP.meta.pagination
        ? {
            ...{
              count: dataAP.meta.pagination.count,
              total: parseInt(dataAP.meta.pagination.total),
              itemsPerPage: dataAP.meta.pagination.per_page,
              totalPage: dataAP.meta.pagination.total_pages,
              current_page: parseInt(dataAP.meta.pagination.current_page)
            }
          }
        : state.unassignedLevelActivitiesPagination;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES_LEVEL_ASSIGNED]: (
    state,
    data
  ) => {
    let dataAP = data.responseAP;
    let dataProgramServ = data.responseProgramServ;
    if (dataAP.length === 0 || dataProgramServ.length === 0) {
      state.assignedLevelActivities = [];
      state.assignedLevelActivitiesPagination = {
        count: 0,
        total: 0,
        current_page: 1,
        totalPage: 0
      };
    } else {
      let dataViewModel = transform.convertProgramActivitiesViewModel(dataAP);
      dataViewModel.forEach(item => {
        const index = dataProgramServ.findIndex(
          t => t.activityId === item.id.toString()
        );
        if (index >= 0) {
          item.ProgramActivityId = dataProgramServ[index].id || "";
        }
      });
      state.assignedLevelActivities = dataViewModel;
      state.assignedLevelActivitiesPagination =
        dataAP.meta && dataAP.meta.pagination
          ? {
              ...{
                count: dataAP.meta.pagination.count,
                total: parseInt(dataAP.meta.pagination.total),
                itemsPerPage: dataAP.meta.pagination.per_page,
                totalPage: dataAP.meta.pagination.total_pages,
                current_page: parseInt(dataAP.meta.pagination.current_page)
              }
            }
          : state.assignedLevelActivitiesPagination;
    }
  },
  [activityConst.MUTATION_REFRESH_PHASE_AFTER_DELETION]: (state, options) => {
    const index = state.phases.findIndex(
      t => t.id.toString() === options.phaseId.toString()
    );
    if (index >= 0 && state.phases[index].activities) {
      let data = state.phases[index].activities.data;
      options.removeIds.forEach(deletedItem => {
        const indexDeleted = data.findIndex(
          t => t.ProgramActivityId === deletedItem
        );
        if (indexDeleted >= 0) {
          data.splice(indexDeleted, 1);
        }
      });
    }
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITY]: (state, activity) => {
    state.activity = activity;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITY_AVAILABLE]: (state, data) => {
    if (data) {
      data.startDate = "";
      data.endDate = "";
    }
    state.availableActivityDetail = data;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITY_CUSTOM]: ({ commit }, data) => {
    state.customActivityDetail = data;
    state.customActivityDetail.startDate = commonUtils.getDateFromDateTime(
      data.startDate
    );
    state.customActivityDetail.endDate = commonUtils.getDateFromDateTime(
      data.endDate
    );
  },
  [activityConst.MUTATION_CLEAR_PROGRAM_ACTIVITIES_CUSTOM]: state => {
    state.availableActivities = [];
    state.customActivities = [];
    state.availableActivityDetail = {};
    state.customActivityDetail = {};
  },
  [activityConst.MUTATION_SET_LEVEL_ACTIVITIES_FILTERS]: (state, payload) => {
    state.levelActivitiesFilter = payload;
  },
  [activityConst.MUTATION_SET_LEVEL_ACTIVITIES_MODAL_FILTERS]: (
    state,
    payload
  ) => {
    state.levelActivitiesModalFilter = payload;
  },
  [activityConst.MUTATION_SET_CALENDAR_PHASE_SELECTED_ID]: (state, payload) => {
    state.calendarPhaseSelectedId = payload;
  },
  [activityConst.MUTATION_SET_IS_LOADING_ACTIVITY_DATA]: (state, payload) => {
    state.isLoadingActivityData = payload;
  },
  [activityConst.MUTATION_SET_PROGRAM_ACTIVITIES]: (state, payload) => {
    state.programActivities = payload;
  },
  [activityConst.MUTATION_SET_LES_MILLS_RESOURCE]: (state, data) => {
    state.lesMillsResource = data;
  },
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_activities/index.js